import { TOKEN_KEY, USER_KEY } from '../constants/constants';
export default () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
};
//# sourceMappingURL=cleanAuthData.js.map